export default {
    // Shared with master builder
    selectedItem: null,
    draggedElement: null,
    currentGlobalConfig: {},
    isDragMode: false,
    // Specific for Doc Builder
    currentMenuTab: null,
    isResizeMode: false,
    isDocumentTemplate: null,
    parentPage: null,
    parentSection: null,
    parentColumn: null,
    emptyHoveredColumnId: null,
    parentElement: null,
    elementChildSelected: null,
    elementChildrenSelected: [],
    emailTarget: null
}
